import React, { useEffect, useMemo } from 'react';
import styled from "styled-components";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { useDispatch, useSelector } from "react-redux";
import { HeadlineMedium, HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { HorizontalSpacer } from '@shared/ui/atoms/VerticalSpacer';
import { LinkButton } from '@shared/ui/atoms/buttons/LinkButton';
import { MeetingRoomLimitReachedMessage } from "../../meeting-rooms/components/MeetingRoomLimitReachedMessage";
import { MeetingRoom } from "../../../../meeting-rooms/models/MeetingRooms";
import { MeetingRoomContentCard } from "../../meeting-rooms/components/MeetingRoomContentCard";
import { ManageMeetingRoomsIntroduction } from "../../meeting-rooms/components/ManageMeetingRoomsIntroduction";
import { isLoading, loadMeetingRooms, selectAllMeetingRooms } from "../../meeting-rooms/meeting-rooms-settings.duck";
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { useTranslation } from "react-i18next";
import { sortOffice } from '@shared/utils/OfficeHelper';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

interface MeetingRoomWithOffice {
  office: OfficeEntity;
  meetingRooms: MeetingRoom[];
}

export function MeetingRoomsPanel(props: Props) {
  const {office} = props;
  const {t} = useTranslation();
  const allOffices = useSelector(selectAllOfficeEntities);
  const dispatch = useDispatch();
  const meetingRooms = useSelector(selectAllMeetingRooms);
  const loading = useSelector(isLoading);

  const meetingRoomsInOffice = useMemo(() => {
    const officesToCheck = allOffices.filter((ao: OfficeEntity) => ao.parentId === office.id || ao.id === office.id).sort(sortOffice);

    return officesToCheck.map((o: OfficeEntity) => {
      return {
        office: o,
        meetingRooms: meetingRooms.filter(mr => mr.officeId === o.id).sort((a, b) => a.name.localeCompare(b.name))
      }
    }).filter((otc: any) => otc.meetingRooms.length > 0);
  }, [allOffices, meetingRooms, office.id]);

  useEffect(() => {
    dispatch(loadMeetingRooms());
  }, [dispatch]);

  return (
    <Container>
      <HeadlineMedium style={{marginBottom: 24}}>{t('settings-page.meeting-rooms')}</HeadlineMedium>

      {loading ? <></> : <>
        {meetingRoomsInOffice.length > 0 ? <>
          <LinkButton size={ButtonSize.Large}
                      link={`/manage/meeting-rooms/add/${office.id}`}
                      text={'settings.meeting-rooms.add-meeting-rooms'} />

          <HorizontalSpacer />

          <MeetingRoomLimitReachedMessage />
          <MeetingRoomList>
            {meetingRoomsInOffice.map((mro: MeetingRoomWithOffice) => (<>
              <HeadlineSmall style={{marginTop: 32, marginBottom: 16}}>{mro.office.label}</HeadlineSmall>
              {mro.meetingRooms.map((meetingRoom: MeetingRoom, key: number) => <MeetingRoomContentCard key={key}
                                                                                                       meetingRoom={meetingRoom} />)}
            </>))}
          </MeetingRoomList>
        </> : <>
          <ManageMeetingRoomsIntroduction />
          <LinkButton fullWidth={true} size={ButtonSize.Large}
                      link={`/manage/meeting-rooms/add/${office.id}`}
                      text={'settings.meeting-rooms.add-meeting-rooms'} />

        </>}
      </>}

    </Container>
  )
}

interface Props {
  office: OfficeEntity;
}

const Container = styled.div`
`

const MeetingRoomList = styled.div`
  margin-bottom: 24px;
`
